import React from "react";
import range from "../../utils/range";
import Round from "../Buttons/Round/index";

const times = range(1, 13);
const meridiems = ["AM", "PM"];

export default ({ time, onChange }) => [
  <div className="row justify-content-center mx-4 mb-2" key="hour">
    {(times || []).map((hour, i) => (
      <Round
        fontSize={22}
        key={i}
        className="m-1"
        hour={hour}
        active={time.hour === hour}
        onClick={() => onChange(Object.assign({}, time, { hour }))}
      >
        {hour}
      </Round>
    ))}
  </div>,
  <div className="row justify-content-center mx-4" key="meridiem">
    {meridiems.map((meridiem, i) => (
      <Round
        fontSize={22}
        key={i}
        className="m-1"
        meridiem={meridiem}
        active={time.meridiem === meridiem}
        onClick={() => onChange(Object.assign({}, time, { meridiem }))}
      >
        {meridiem}
      </Round>
    ))}
  </div>
];



// WEBPACK FOOTER //
// ./src/components/SwipeToggle/times.js